import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { BaseComponent } from '@uw/core/base.component';
import { MetadataService } from '@uw/core/services/metadata.service';
import { Observable } from 'rxjs';
import { KeyValueModel } from '@uw/core/models/keyvalue.model';
import { AuthService } from '@uw/core/services/auth.service';
import { ProfilePageComponent } from '@uw/modules/profile/pages/profile-page/profile-page.component';
import { ProfileService } from '@uw/core/services/profile.service';
import { UtilsService, validateAllFormFields } from '@uw/core/services/utils.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { CampaignPageContent } from '@uw/core/models/campaign.model';
import { CampaignStateService } from '@uw/core/services/campaign-state.service';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { NgClass, AsyncPipe } from '@angular/common';
import { FieldErrorDisplayComponent } from '../../../../shared/components/field-error-display/field-error-display.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { SafeHtmlPipe } from '../../../../shared/pipes/santized-html.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    templateUrl: './donation-optout-modal.component.html',
    styleUrls: ['./donation-optout-modal.component.scss'],
    imports: [MatIconButton, ReactiveFormsModule, NgClass, FieldErrorDisplayComponent, MatButton, ButtonComponent, AsyncPipe, SafeHtmlPipe, TranslateModule]
})
export class DonationOptoutModalComponent extends BaseComponent implements OnInit {

  optOutFormGroup!: UntypedFormGroup;
  optOutReasonsList$!: Observable<KeyValueModel[]>;
  buttonLoading = false;
  pageContent!: Map<string, CampaignPageContent>;
  optOutMessage!: string | null;

  constructor(
    private fb: UntypedFormBuilder,
    private profileService: ProfileService,
    private authService: AuthService,
    private customNavigationService: CustomNavigationService,
    public campaignService: CampaignService,
    public campaingStateService: CampaignStateService,
    private metadataService: MetadataService,
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: Map<string, CampaignPageContent>,
    public dialogRef: MatDialogRef<ProfilePageComponent>) {
    super();
    this.pageContent = data;
    this.createForm();
    this.loadContent();
  }

  ngOnInit(): void {
    this.optOutReasonsList$ = this.metadataService.getOptoutReasons();
  }

  private createForm(): void {
    this.optOutFormGroup = this.fb.group({
      reason: [null, { validators: [Validators.required] }],
      comments: [{
        value: null,
        disabled: true
      }, { validators: [Validators.required] }],
    });
  }

  onSave() {
    if (!this.optOutFormGroup.valid) {
      validateAllFormFields(this.optOutFormGroup);
      return;
    }
    this.buttonLoading = true;
    this.profileService.optOutFromCampaign(this.optOutFormGroup.value).subscribe(_c => {

        this.buttonLoading = false;
        this.dialogRef.close();

    }, _err => {
      this.buttonLoading = false;
      this.showError('donation_optout.information_not_updated');
    });
  }

  onReasonChange($event: Event) {
    const value = ($event.target as HTMLInputElement).value;
    if (value === 'Other' || value === 'Autre') {
      this.optOutFormGroup.get('comments')?.enable();
    } else {
      this.optOutFormGroup.get('comments')?.reset();
      this.optOutFormGroup.get('comments')?.disable();
    }
  }

  onCancel(): void {
    this.dialogRef.close();
    this.customNavigationService.navigate(['/donor', this.campaingStateService.getSelectedCampaign()?.campaignGuid]);
  }

  isFieldValid(field: string) {
    return (!this.optOutFormGroup.get(field)?.valid && this.optOutFormGroup.get(field)?.touched) ?? false;
  }

  loadContent() {
    this.optOutMessage = this.getContent('Optout_Message');
  }

  getContent(key: string) {
    if (this.pageContent && this.pageContent.has(key)) {
      return this.pageContent.get(key)?.contentXML ?? null;
    }
    return null;
  }

}
